module.exports = __webpack_public_path__ + "static/media/swap_horiz.2e7798d0.svg";